import axios from '../../../shared/authAxios';
import { endpoints } from '../../../api/endpoints';
import moment from "moment";

function list({ rowsPerPage, page, sortBy, sortDirection, query }) {
  return axios({
    'url': endpoints.tenant.list,
    'method': 'POST',
    'data': {
      rowsPerPage,
      page,
      sortBy: [sortBy === "id" ? "_id" : sortBy],
      sortDirection: [sortDirection.toUpperCase()],
      query,
    },
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        if (r.data.rows == null) r.data.rows = [];
        return r.data
      }
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return err
        } else {
          return err.response.data;
        }
      }

      return err;
    })
}

function fullList(extend) {
  const postData = {
    rowsPerPage: 65000,
    page: 0,
    sortBy: ["_id"],
    sortDirection: ["ASC"],
    fields: ["_id", "name", "login_host"],
  };

  if (extend) {
    const keys = Object.keys(extend);
    keys.forEach(key => {
      postData[key] = extend[key];
    });
  }

  return axios({
    'url': endpoints.tenant.list,
    'method': 'POST',
    'data': postData,
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        if (r.data.rows == null) r.data.rows = [];
        return r.data
      }
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return err
        } else {
          return err.response.data;
        }
      }

      return err;
    })
}

function fullComputedTenantList() {
  const postData = {
    rows_per_page: 65000,
    page: 0,
    time_start: moment(),
    time_end: moment(),
  };

  return axios({
    'url': endpoints.tenant.get_computed_list,
    'method': 'POST',
    'data': postData,
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        if (r.data.rows == null) r.data.rows = [];
        return r.data
      }
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return err
        } else {
          return err.response.data;
        }
      }

      return err;
    })
}

function save(tenant) {
  let method = "POST";
  let url = endpoints.tenant.save

  if (tenant.id) {
    method = "PUT"
    url += "/" + tenant.id
  }

  delete (tenant.id)

  return axios({
    'url': url,
    'method': method,
    'data': tenant,
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        return r.data.tenant;
      }
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return Promise.reject(err)
        } else {
          return Promise.reject(err.response.data);
        }
      }

      return Promise.reject(err);
    })
}

function load(id) {
  let method = "GET";
  let url = endpoints.tenant.save + '/' + id

  return axios({
    'url': url,
    'method': method,
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        return r.data.tenant;
      }
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return err
        } else {
          return err.response.data;
        }
      }

      return err;
    })
}

function loadRealtimeData(idsList) {
  let method = "GET";
  let url = endpoints.tenant.realtime;
  url = url.replace(":idsList", idsList);

  return axios({
    'url': url,
    'method': method,
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        if (r.data.rows == null) r.data.rows = [];
        return r.data
      }
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return err
        } else {
          return err.response.data;
        }
      }

      return err;
    })
}

function archiveData(id, errcb, succb) {
  let method = "GET";
  let url = endpoints.tenant.archive + '/' + id

  return axios({
    'url': url,
    'method': method,
  })
    .then(response => {
      if (response.status === 200) {
        if (typeof succb === 'function') succb(true);
      }
      return response;
    })
    .catch(err => {
      if (typeof errcb === 'function') errcb(err);
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return err
        } else {
          return err.response.data;
        }
      }

      return err;
    })
}

function unarchiveData(id, errcb, succb) {
  let method = "POST";
  let url = endpoints.tenant.unarchive + '/' + id

  return axios({
    'url': url,
    'method': method,
    'data': { id }
  })
    .then(response => {
      if (response.status === 200) {
        if (typeof succb === 'function') succb(true);
      }
      return response;
    })
    .catch(err => {
      if (typeof errcb === 'function') errcb(err);
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return err
        } else {
          return err.response.data;
        }
      }

      return err;
    })
}

const loadFraudDetector = id => {
  let method = "GET";
  let url = endpoints.tenant.fraud_detector;
  url = url.replace(":id", id);

  return axios({
    'url': url,
    'method': method,
  }).then(response => {
    const r = response.data;

    if (r) {
      return r
    }
  }).catch(err => {
    if (err.response && err.response.data) {
      if (typeof err.response.data === 'string') {
        return err
      } else {
        return err.response.data;
      }
    }

    return err;
  })
}

const saveFraudDetector = data => {
  let method = "PUT";
  let url = endpoints.tenant.fraud_detector;

  if (data.id != "") {
    url = url.replace(":id", data.id);
    delete (data.id);
  }

  return axios({
    'url': url,
    'method': method,
    'data': data,
  }).then(response => {
    const r = response;
    if (r.status === 200) {
      return true;
    }
  }).catch(err => {
    if (err.response && err.response.data) {
      if (typeof err.response.data === 'string') {
        return Promise.reject(err);
      } else {
        return Promise.reject(err.response.data);
      }
    }

    return Promise.reject(err);
  })
}

export const tenantService = {
  list,
  fullList,
  fullComputedTenantList,
  save,
  load,
  loadRealtimeData,
  archiveData,
  unarchiveData,
  loadFraudDetector,
  saveFraudDetector
};
